import { React, useState } from "react";
import "./AdminTableHeader.scss";
import { Box } from "@mui/material";

function AdminTableHeader({ count, portalFilterList }) {

  return (
    <Box className="admin-table-info-header pb-0">
      <Box
        sx={{
          color: "#00365a",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "30px",
        }}
      >
        Total: {portalFilterList ? portalFilterList.length : <>0</>} Accounts
      </Box>
      <Box className="table-options">
        {/* <Select 
          name="" 
          id="date-options"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{
            color: "#00365A",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px !important", 
            borderRadius: "30px",
            border: "'url('../../images/arrow-down.svg') no-repeat 1px solid var(--grey-grey-30, #EAEEF4)",
            background: "var(--primary-white, #FFF)",
            padding: "5px 10px",
            backgroundPositions: 'calc(100% - 0.75rem) center !important',
            appearance: 'none !important',
            MozAppearance: 'none !important',
            WebkitAppearance: 'none !important',
            paddingRight: "3rem !important",
          }}
        > */}
          {/* <MenuItem value="date">Sort By: Date Created</MenuItem>
          <MenuItem value="newest">Sort By: Newest User</MenuItem>
          <MenuItem value="oldest">Sort By: Oldest User</MenuItem> */}
        {/* </Select> */}

        {/* <div className="filter-buttons d-flex gap-2">
          <button onClick={() => setFilter("Requires KYC")}>
            Requires KYC
          </button>
          <button onClick={() => setFilter("Approved User")}>
            Approved User
          </button>
          <button onClick={() => setFilter("Requires Approval")}>
            Requires Approval
          </button>
          <button onClick={() => setFilter(null)}>Clear Filter</button>
        </div> */}

        {/* <Button
          sx={{
            color: "#00365A",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px !important",
            borderRadius: "30px",
            border: "1px solid var(--grey-grey-30, #EAEEF4)",
            background: "var(--primary-white, #FFF)",
            padding: "5px 20px",
            display:"flex",
            gap: "13px",
            alignItems: "center",
          }}
        >
          <Box>Filter</Box>
          <img alt="Filter Icon" src={Filter} />
        </Button> */}
      </Box>
    </Box>
  );
}

export default AdminTableHeader;
